import { useCallback, useEffect, useState } from 'react'
import { clientesService, type ClienteAgradaRow } from '@/services/clientesService'

export type ClientesFilter = 'todos' | 'novos_30d' | 'com_projeto' | 'importados'

export function useClientesAgradaPage() {
  const [filter, setFilter] = useState<ClientesFilter>('todos')
  const [search, setSearch] = useState('')
  const [clientes, setClientes] = useState<ClienteAgradaRow[]>([])
  const [totalItems, setTotalItems] = useState(0)
  const [loading, setLoading] = useState(true)

  const load = useCallback(async () => {
    setLoading(true)
    try {
      const res = await clientesService.list({ page: 1, limit: 50, search: search || undefined, filter })
      setClientes(res.data)
      setTotalItems(res.meta?.totalItems ?? res.data.length)
    } catch {
      setClientes([])
      setTotalItems(0)
    } finally {
      setLoading(false)
    }
  }, [filter, search])

  useEffect(() => {
    const t = setTimeout(() => void load(), search ? 300 : 0)
    return () => clearTimeout(t)
  }, [load, search])

  return {
    filter,
    setFilter,
    search,
    setSearch,
    clientes,
    totalItems,
    loading,
    reload: load,
  }
}
